
import {
  Component, Prop, Watch, Mixins,
} from 'vue-property-decorator';
import { ContactDetails, OperationInfo } from '@/types';
import LeadCustomerContent from '@/components/LeadCustomerContent.vue';
import EditLeadCustomerDialog from '@/components/EditLeadCustomerDialog.vue';
import UtilsMixin from '@/mixins/UtilsMixin.vue';

@Component({
  components: {
    LeadCustomerContent,
    EditLeadCustomerDialog,
  },
})
export default class OperationCustomer extends Mixins(UtilsMixin) {
  @Prop(Object) readonly operationInfo: OperationInfo | undefined;

  editDialog = false

  loading = false

  @Watch('editDialog')
  onEditDialogChange(val: boolean) {
    // Se è stato chiuso il dialog...
    if (val === false) {
      // ... nasconde il tooltip
      this.$nextTick(() => {
        (this.$refs.tippyRef as any).tippy().hide();
      });

      // ... emette l'evento "close"
      this.$emit('close');
    }
  }

  get poolUpdating(): { [key: number]: boolean } {
    return this.$store.getters.currentOperationsPoolUpdating;
  }

  get contactDetails(): ContactDetails | null {
    return this.operationInfo?.contactDetails
      ? JSON.parse(this.operationInfo.contactDetails)
      : null;
  }

  get isEditable() {
    return this.hasPermission('leads.customer.modify');
  }

  name(type: 'contact' | 'billing' | 'installation' = 'contact') {
    switch (type) {
      case 'billing':
        return this.operationInfo?.billingType === 'person'
          ? `${this.operationInfo?.billingFirstName} ${this.operationInfo?.billingLastName}`
          : this.operationInfo?.billingCompany;

      case 'installation':
        return this.operationInfo?.installationType === 'person'
          ? `${this.operationInfo?.installationFirstName} ${this.operationInfo?.installationLastName}`
          : this.operationInfo?.installationCompany;

      default:
        break;
    }

    return this.operationInfo?.customerType === 'person'
      ? `${this.operationInfo?.firstName} ${this.operationInfo?.lastName}`
      : this.operationInfo?.company;
  }

  icon(type: 'contact' | 'billing' | 'installation' = 'contact') {
    switch (type) {
      case 'billing':
        return this.operationInfo?.billingType === 'person'
          ? 'mdi-receipt'
          : 'mdi-receipt';

      case 'installation':
        return this.operationInfo?.installationType === 'person'
          ? 'mdi-home-map-marker'
          : 'mdi-home-map-marker';

      default:
        break;
    }

    return this.operationInfo?.customerType === 'person'
      ? 'mdi-account'
      : 'mdi-domain';
  }

  iconText(type: 'contact' | 'billing' | 'installation' = 'contact') {
    switch (type) {
      case 'billing':
        return 'Fatturazione';

      case 'installation':
        return 'Bolletta/Installazione';

      default:
        break;
    }

    return 'Contatto';
  }

  async onEdit() {
    if (!this.isEditable) return;

    this.loading = true;

    await this.$store.dispatch('selectLead', { id: this.operationInfo?.id });

    this.$nextTick(() => {
      (this.$refs.tippyRef as any).tippy().hide();
    });

    this.editDialog = true;

    this.loading = false;
  }
}
